import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import AdminFormModal from '../shared/AdminFormModal';

const EditAreaModal = ({ show, onClose, area, onAreaUpdated }) => {
  const [name, setName] = useState('');

  useEffect(() => {
    if (area) {
      setName(area.name);
    }
  }, [area]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    await onAreaUpdated({ ...area, name });
    onClose();
  };

  return (
    <AdminFormModal
      show={show}
      onClose={onClose}
      title="Alanı Düzenle"
      subtitle="Alan adını güncelleyin. Ekip ve ürün kapsamı korunur."
      icon={faEdit}
      footer={(
        <>
          <div className="admin-modal-footer-secondary">
            <Button variant="secondary" onClick={onClose} className="modal-cancel-btn">
              İptal
            </Button>
          </div>
          <div className="admin-modal-footer-primary">
            <Button variant="primary" onClick={handleSubmit} className="modal-save-btn modal-save-btn-success">
              Kaydet
            </Button>
          </div>
        </>
      )}
    >
      <Form onSubmit={handleSubmit} className="admin-form-section">
        <div className="admin-form-block">
          <div className="admin-form-block-title">
            <FontAwesomeIcon icon={faMapMarkerAlt} />
            Alan Bilgisi
          </div>
          <div className="admin-modal-field">
            <Form.Label>Alan Adı</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(event) => setName(event.target.value)}
              className="form-input"
              placeholder="Alan adını giriniz"
              required
            />
          </div>
        </div>
      </Form>
    </AdminFormModal>
  );
};

export default EditAreaModal;
